var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-4 w-4",class:{ 'text-gray-900 spinner': _vm.isLoading }},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }